import React from 'react';
import cx from 'classnames';

import {
    Avatar,
    AvatarType,
    FontVariant,
    TextHeading,
    Text,
} from '@pexip/components';

import styles from './CallHistoryItemMoreMenuHeader.module.scss';

export const CallHistoryItemMoreMenuHeader: React.FC<
    React.ComponentProps<'div'> & {
        isTouchDevice: boolean;
        title?: string;
        meetingId: string;
    }
> = ({isTouchDevice, className, title, meetingId}) => {
    return (
        <div className={cx(styles.container, className)}>
            <Avatar
                colorScheme="light"
                displayName={title ?? meetingId}
                sizeModifier="md"
                type={AvatarType.Initials}
            />
            <TextHeading
                htmlTag={isTouchDevice ? FontVariant.H2 : FontVariant.H5}
                fontVariant={isTouchDevice ? FontVariant.H2 : FontVariant.H5}
                className={`${isTouchDevice ? 'mt-3' : 'mt-1'} text-center`}
            >
                {title ?? meetingId}
            </TextHeading>
            {title && meetingId && (
                <Text className={cx(styles.meetingIdContainer, 'text-center')}>
                    {meetingId}
                </Text>
            )}
        </div>
    );
};
